import { render, staticRenderFns } from "./subTabPage.vue?vue&type=template&id=acae861c&scoped=true&"
import script from "./subTabPage.vue?vue&type=script&lang=js&"
export * from "./subTabPage.vue?vue&type=script&lang=js&"
import style0 from "./subTabPage.vue?vue&type=style&index=0&id=acae861c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acae861c",
  null
  
)

export default component.exports